
/**
 * Determines when running in run time.
 * 
 * @returns {boolean} browser environment found
 */
export function isRunTime() {
    return typeof window !== "undefined";
}